/* --------------------------------------------------------------------------------------
   scan.module.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/
import { scanBrowseComponent } from "./components/scanBrowse.component";
import { scanSettingsComponent } from "./components/scanSettings.component";
import { scanActionBarComponent } from "./components/scanActionBar.component";
import { scanSettingsFileSectionComponent } from "./components/scanSettingsFileSection.component";
import { scanSettingsScanSectionComponent } from "./components/scanSettingsScanSection.component";
import { scanPreviewComponent } from "./components/scanPreview.component";
import { categoriesPopupComponent } from "./components/categoriesPopup.component";
import { pdfSettingsPopupComponent } from "./components/pdfSettingsPopup.component";
import { languagesPopupComponent } from "./components/languagesPopup.component";

import { scanService } from "./services/scan.service";

export const appScanModule = angular
  .module("app.scan", [])
  .component("scanBrowse", scanBrowseComponent)
  .component("scanSettings", scanSettingsComponent)
  .component("scanActionBar", scanActionBarComponent)
  .component("scanSettingsFileSection", scanSettingsFileSectionComponent)
  .component("scanSettingsScanSection", scanSettingsScanSectionComponent)
  .component("scanPreview", scanPreviewComponent)
  .component("categoriesPopup", categoriesPopupComponent)
  .component("pdfSettingsPopup", pdfSettingsPopupComponent)
  .component("languagesPopup", languagesPopupComponent)
  .service("scanService", scanService);



// WEBPACK FOOTER //
// ./src/app/scan/scan.module.js